{
  "HELP_CENTER": {
    "TITLE": "Hilfezentrum",
    "NEW_PAGE": {
      "DESCRIPTION": "Erstellen Sie Self-Service-Portale für Ihr Hilfezentrum, damit Kunden schnell Antworten finden, ohne warten zu müssen. Optimieren Sie Anfragen, steigern Sie die Effizienz Ihrer Agents und verbessern Sie den Kundensupport.",
      "CREATE_PORTAL_BUTTON": "Portal erstellen"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Ohne Titel"
    },
    "HEADER": {
      "FILTER": "Filtern nach",
      "SORT": "Sortieren nach",
      "LOCALE": "Sprache",
      "SETTINGS_BUTTON": "Einstellungen",
      "NEW_BUTTON": "Neuer Artikel",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Veröffentlicht",
        "DRAFT": "Draft",
        "ARCHIVED": "Archiviert"
      },
      "TITLES": {
        "ALL_ARTICLES": "Alle Artikel",
        "MINE": "Meine Artikel",
        "DRAFT": "Draft-Artikel",
        "ARCHIVED": "Archivierte Artikel"
      },
      "LOCALE_SELECT": {
        "TITLE": "Sprache auswählen",
        "PLACEHOLDER": "Sprache auswählen",
        "NO_RESULT": "Keine Sprache gefunden",
        "SEARCH_PLACEHOLDER": "Sprache suchen"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Alle Artikel",
      "PUBLISH_BUTTON": "Veröffentlichen",
      "MOVE_TO_ARCHIVE_BUTTON": "Zu archiviert verschieben",
      "PREVIEW": "Vorschau",
      "ADD_TRANSLATION": "Übersetzung hinzufügen",
      "OPEN_SIDEBAR": "Seitenleiste öffnen",
      "CLOSE_SIDEBAR": "Seitenleiste schließen",
      "SAVING": "Speichern...",
      "SAVED": "Gespeichert"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Bild hochladen",
        "UPLOADING": "Hochladen...",
        "SUCCESS": "Bild erfolgreich hochgeladen",
        "ERROR": "Fehler beim Hochladen des Bildes",
        "UN_AUTHORIZED_ERROR": "Sie sind nicht berechtigt, Bilder hochzuladen",
        "ERROR_FILE_SIZE": "Bildgröße sollte kleiner als {size}MB sein",
        "ERROR_FILE_FORMAT": "Bildformat sollte jpg, jpeg oder png sein",
        "ERROR_FILE_DIMENSIONS": "Bildgröße sollte kleiner als 2000 x 2000 sein"
      },
      "ANCHOR": {
        "BUTTON": "Anker einfügen",
        "TITLE": "Anker einfügen",
        "SUBMIT": "Einfügen",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Artikeleinstellungen",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategorie",
          "TITLE": "Kategorie wählen",
          "PLACEHOLDER": "Kategorie wählen",
          "NO_RESULT": "Keine Kategorie gefunden",
          "SEARCH_PLACEHOLDER": "Kategorie suchen"
        },
        "AUTHOR": {
          "LABEL": "Autor",
          "TITLE": "Autor auswählen",
          "PLACEHOLDER": "Autor auswählen",
          "NO_RESULT": "Keine Autoren gefunden",
          "SEARCH_PLACEHOLDER": "Autor suchen"
        },
        "META_TITLE": {
          "LABEL": "Meta-Titel",
          "PLACEHOLDER": "Metatitel hinzufügen"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta-Beschreibung",
          "PLACEHOLDER": "Fügen Sie Ihre Meta-Beschreibung hinzu, um bessere SEO-Ergebnisse zu erzielen..."
        },
        "META_TAGS": {
          "LABEL": "Meta-Tags",
          "PLACEHOLDER": "Meta-Tags durch Komma getrennt hinzufügen..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Artikel archivieren",
        "DELETE": "Artikel löschen"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Nicht kategorisiert",
      "SEARCH_RESULTS": "Suchergebnisse für {query}",
      "EMPTY_TEXT": "Suche nach Artikeln, um sie in Antworten einzufügen.",
      "SEARCH_LOADER": "Suchen...",
      "INSERT_ARTICLE": "Einfügen",
      "NO_RESULT": "Keine Artikel gefunden",
      "COPY_LINK": "Artikellink in die Zwischenablage kopieren",
      "OPEN_LINK": "Artikel in neuem Fenster öffnen",
      "PREVIEW_LINK": "Artikelvorschau anzeigen"
    },
    "PORTAL": {
      "HEADER": "Portale",
      "DEFAULT": "Standard",
      "NEW_BUTTON": "Neues Portal",
      "ACTIVE_BADGE": "aktiv",
      "CHOOSE_LOCALE_LABEL": "Wählen Sie ein Gebietsschema",
      "LOADING_MESSAGE": "Portale werden geladen...",
      "ARTICLES_LABEL": "Artikel",
      "NO_PORTALS_MESSAGE": "Es sind keine Portale verfügbar",
      "ADD_NEW_LOCALE": "Neues Gebietsschema hinzufügen",
      "POPOVER": {
        "TITLE": "Portale",
        "PORTAL_SETTINGS": "Portaleinstellungen",
        "SUBTITLE": "Sie haben mehrere Portale und können für jedes Portal unterschiedliche Gebietsschemata haben.",
        "CANCEL_BUTTON_LABEL": "Stornieren",
        "CHOOSE_LOCALE_BUTTON": "Gebietsschema wählen"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "Artikel",
            "ADD": "Sprache hinzufügen",
            "VISIT": "Seite besuchen",
            "SETTINGS": "Einstellungen",
            "DELETE": "Löschen"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Portalkonfigurationen",
            "ITEMS": {
              "NAME": "Name",
              "DOMAIN": "Benutzerdefinierte Domain",
              "SLUG": "Slug",
              "TITLE": "Titel des Portals",
              "THEME": "Themenfarbe",
              "SUB_TEXT": "Portal-Untertext"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Verfügbare Sprachen",
            "TABLE": {
              "NAME": "Name der Sprache",
              "CODE": "Sprachcode",
              "ARTICLE_COUNT": "Anzahl Artikel",
              "CATEGORIES": "Anzahl der Kategorien",
              "SWAP": "Tauschen",
              "DELETE": "Löschen",
              "DEFAULT_LOCALE": "Standard"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Portal löschen",
          "MESSAGE": "Möchten Sie dieses Portal wirklich löschen",
          "YES": "Ja, Portal löschen",
          "NO": "Nein, Portal behalten",
          "API": {
            "DELETE_SUCCESS": "Portal erfolgreich gelöscht",
            "DELETE_ERROR": "Fehler beim Löschen des Portals"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Portal bearbeiten",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Grundinformation"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Portalanpassung"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategorien"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Sprachen"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategorien in",
          "NEW_CATEGORY": "Neue Kategorie",
          "TABLE": {
            "NAME": "Name",
            "DESCRIPTION": "Beschreibung",
            "LOCALE": "Sprache",
            "ARTICLE_COUNT": "Anzahl Artikel",
            "ACTION_BUTTON": {
              "EDIT": "Kategorie bearbeiten",
              "DELETE": "Kategorie löschen"
            },
            "EMPTY_TEXT": "Keine Kategorien gefunden"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Grundeinstellungen aktualisieren"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informationen zum Hilfezentrum",
            "BODY": "Grundlegende Informationen zum Portal"
          },
          "CUSTOMIZATION": {
            "TITLE": "Anpassung des Help Centers",
            "BODY": "Portal anpassen"
          },
          "FINISH": {
            "TITLE": "Voila! 🎉",
            "BODY": "Sie sind bereit!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Zurück",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Portal erstellen",
            "TITLE": "Informationen zum Hilfezentrum",
            "CREATE_BASIC_SETTING_BUTTON": "Portalgrundeinstellungen erstellen"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Portalanpassung",
            "TITLE": "Anpassung des Help Centers",
            "UPDATE_PORTAL_BUTTON": "Portaleinstellungen aktualisieren"
          },
          "FINISH_PAGE": {
            "TITLE": "Voila!🎉 Sie sind fertig!",
            "MESSAGE": "Sie können dieses erstellte Portal jetzt auf Ihrer Seite \"Alle Portale\" sehen.",
            "FINISH": "Zur Seite Alle Portale"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Logo hochladen",
          "HELP_TEXT": "Dieses Logo wird in der Kopfzeile des Portals angezeigt.",
          "IMAGE_UPLOAD_SUCCESS": "Logo erfolgreich hochgeladen",
          "IMAGE_UPLOAD_ERROR": "Logo erfolgreich gelöscht",
          "IMAGE_DELETE_ERROR": "Fehler beim Löschen des Logos"
        },
        "NAME": {
          "LABEL": "Name",
          "PLACEHOLDER": "Portalname",
          "HELP_TEXT": "Der Name wird intern im öffentlich zugänglichen Portal verwendet.",
          "ERROR": "Name wird benötigt"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal-Slug für URLs",
          "ERROR": "Slug ist erforderlich"
        },
        "DOMAIN": {
          "LABEL": "Benutzerdefinierte Domain",
          "PLACEHOLDER": "Benutzerdefinierte Domain des Portals",
          "HELP_TEXT": "Nur hinzufügen, wenn Sie eine benutzerdefinierte Domain für Ihre Portale verwenden möchten. Beispiel: {exampleURL}",
          "ERROR": "Geben Sie eine gültige Domänen-URL ein"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Homepage-Link",
          "PLACEHOLDER": "Link zur Startseite des Portals",
          "HELP_TEXT": "Der Link, der verwendet wird, um vom Portal zur Startseite zurückzukehren. Beispiel: {exampleURL}",
          "ERROR": "Geben Sie eine gültige Startseiten-URL ein"
        },
        "THEME_COLOR": {
          "LABEL": "Farbe des Portaldesigns",
          "HELP_TEXT": "Diese Farbe wird als Designfarbe für das Portal angezeigt."
        },
        "PAGE_TITLE": {
          "LABEL": "Seitentitel",
          "PLACEHOLDER": "Titel der Portalseite",
          "HELP_TEXT": "Der Seitentitel wird im öffentlich zugänglichen Portal verwendet.",
          "ERROR": "Seitentitel ist erforderlich"
        },
        "HEADER_TEXT": {
          "LABEL": "Überschrift",
          "PLACEHOLDER": "Portal-Header-Text",
          "HELP_TEXT": "Der Kopfzeilentext des Portals wird im öffentlich zugänglichen Portal verwendet.",
          "ERROR": "Portal-Kopfzeilentext ist erforderlich"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal erfolgreich erstellt.",
          "ERROR_MESSAGE_FOR_BASIC": "Das Portal konnte nicht erstellt werden. Versuchen Sie es nochmal.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal erfolgreich aktualisiert.",
          "ERROR_MESSAGE_FOR_UPDATE": "Das Portal konnte nicht aktualisiert werden. Versuchen Sie es nochmal."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Neues Gebietsschema hinzufügen",
        "SUB_TITLE": "Dadurch wird Ihrer verfügbaren Übersetzungsliste eine neue Sprache hinzugefügt.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Sprache",
          "PLACEHOLDER": "Wählen Sie ein Gebietsschema",
          "ERROR": "Sprache ist erforderlich"
        },
        "BUTTONS": {
          "CREATE": "Sprache erstellen",
          "CANCEL": "Stornieren"
        },
        "API": {
          "SUCCESS_MESSAGE": "Sprache erfolgreich hinzugefügt",
          "ERROR_MESSAGE": "Sprache kann nicht hinzugefügt werden. Versuchen Sie es nochmal."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Standardsprache erfolgreich aktualisiert",
          "ERROR_MESSAGE": "Die Standardsprache kann nicht aktualisiert werden. Versuchen Sie es nochmal."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Sprache wurde erfolgreich aus dem Portal entfernt",
          "ERROR_MESSAGE": "Sprache kann nicht aus dem Portal entfernt werden. Versuchen Sie es nochmal."
        }
      }
    },
    "TABLE": {
      "404": "Kein Artikel entspricht Ihrer Suche 🔍",
      "LOADING_MESSAGE": "Artikel werden geladen...",
      "NO_ARTICLES": "Es sind keine Artikel verfügbar",
      "HEADERS": {
        "TITLE": "Titel",
        "CATEGORY": "Kategorie",
        "READ_COUNT": "Ansichten",
        "STATUS": "Status",
        "LAST_EDITED": "Zuletzt bearbeitet"
      },
      "COLUMNS": {
        "BY": "von",
        "AUTHOR_NOT_AVAILABLE": "Autor ist nicht verfügbar"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Artikel wird geladen...",
      "TITLE_PLACEHOLDER": "Artikeltitel kommt hier rein",
      "CONTENT_PLACEHOLDER": "Schreiben Sie hier Ihren Artikel",
      "API": {
        "ERROR": "Fehler beim Speichern des Artikels"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Fehler beim Veröffentlichen des Artikels",
        "SUCCESS": "Artikel erfolgreich veröffentlicht"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Fehler beim Archivieren des Artikels",
        "SUCCESS": "Artikel erfolgreich archiviert"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Fehler beim Speichern des Artikels als Draft",
        "SUCCESS": "Artikel erfolgreich als Draft gespeichert"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Löschung bestätigen",
          "MESSAGE": "Möchten Sie den Artikel wirklich löschen?",
          "YES": "Ja, löschen",
          "NO": "Nein, behalte es"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Artikel erfolgreich gelöscht",
        "ERROR_MESSAGE": "Fehler beim Löschen des Artikels"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Bitte fügen Sie die Überschrift und den Inhalt des Artikels hinzu, dann können nur Sie die Einstellungen aktualisieren"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Suche nach Artikeln"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Kategorie erstellen",
        "SUB_TITLE": "Die Kategorie wird im öffentlich zugänglichen Portal verwendet, um Artikel zu kategorisieren.",
        "PORTAL": "Portal",
        "LOCALE": "Sprache",
        "NAME": {
          "LABEL": "Name",
          "PLACEHOLDER": "Kategoriename",
          "HELP_TEXT": "Der Kategoriename und das Symbol werden im öffentlich zugänglichen Portal verwendet, um Artikel zu kategorisieren.",
          "ERROR": "Name wird benötigt"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Kategorie-Slug für URLs",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug ist erforderlich"
        },
        "DESCRIPTION": {
          "LABEL": "Beschreibung",
          "PLACEHOLDER": "Geben Sie eine kurze Beschreibung der Kategorie ein.",
          "ERROR": "Beschreibung wird benötigt"
        },
        "BUTTONS": {
          "CREATE": "Kategorie erstellen",
          "CANCEL": "Abbrechen"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorie erfolgreich erstellt",
          "ERROR_MESSAGE": "Kategorie kann nicht erstellt werden"
        }
      },
      "EDIT": {
        "TITLE": "Eine Kategorie bearbeiten",
        "SUB_TITLE": "Durch das Bearbeiten einer Kategorie wird die Kategorie im öffentlich zugänglichen Portal aktualisiert.",
        "PORTAL": "Portal",
        "LOCALE": "Sprache",
        "NAME": {
          "LABEL": "Name",
          "PLACEHOLDER": "Kategoriename",
          "HELP_TEXT": "Der Kategoriename und das Symbol werden im öffentlich zugänglichen Portal verwendet, um Artikel zu kategorisieren.",
          "ERROR": "Name wird benötigt"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Kategorie-Slug für URLs",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug ist erforderlich"
        },
        "DESCRIPTION": {
          "LABEL": "Beschreibung",
          "PLACEHOLDER": "Geben Sie eine kurze Beschreibung der Kategorie ein.",
          "ERROR": "Beschreibung wird benötigt"
        },
        "BUTTONS": {
          "CREATE": "Kategorie aktualisieren",
          "CANCEL": "Stornieren"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorie erfolgreich aktualisiert",
          "ERROR_MESSAGE": "Kategorie kann nicht aktualisiert werden"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategorie erfolgreich gelöscht",
          "ERROR_MESSAGE": "Kategorie kann nicht gelöscht werden"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Artikel suchen",
      "PLACEHOLDER": "Artikel suchen",
      "NO_RESULT": "Keine Artikel gefunden",
      "SEARCHING": "Suchen...",
      "SEARCH_BUTTON": "Suchen",
      "INSERT_ARTICLE": "Link einfügen",
      "IFRAME_ERROR": "URL ist leer oder ungültig. Inhalt kann nicht angezeigt werden.",
      "OPEN_ARTICLE_SEARCH": "Artikel aus dem Help Center einfügen",
      "SUCCESS_ARTICLE_INSERTED": "Artikel erfolgreich eingefügt",
      "PREVIEW_LINK": "Artikelvorschau anzeigen",
      "CANCEL": "Schließen",
      "BACK": "Zurück",
      "BACK_RESULTS": "Zurück zu den Ergebnissen"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Hilfezentrum",
      "DESCRIPTION": "Erstellen Sie benutzerfreundliche Self Service-Portale. Helfen Sie Ihren Nutzern, auf die Artikel zuzugreifen und rund um die Uhr Unterstützung zu erhalten. Erweitern Sie Ihr Abonnement, um diese Funktion zu aktivieren.",
      "SELF_HOSTED_DESCRIPTION": "Erstellen Sie benutzerfreundliche Self Service-Portale. Helfen Sie Ihren Nutzern, auf die Artikel zuzugreifen und rund um die Uhr Unterstützung zu erhalten. Bitte kontaktieren Sie Ihren Administrator, um diese Funktion zu aktivieren.",
      "BUTTON": {
        "LEARN_MORE": "Mehr erfahren",
        "UPGRADE": "Upgrade durchführen"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Mehrere Portale",
          "DESCRIPTION": "Erstellen Sie mehrere Help Center-Portale für verschiedene Produkte mit demselben Konto."
        },
        "LOCALES": {
          "TITLE": "Vollständige Unterstützung für Sprachen",
          "DESCRIPTION": "Finden Sie das Portal in Ihrer Sprache. Wir unterstützen alle Sprachen und ermöglichen Übersetzungen für jeden Artikel."
        },
        "SEO": {
          "TITLE": "SEO-freundliches Design",
          "DESCRIPTION": "Passen Sie Ihre Meta-Tags an, um Ihre Sichtbarkeit in Suchmaschinen mit unseren SEO-freundlichen Seiten zu verbessern."
        },
        "API": {
          "TITLE": "Vollständige API-Unterstützung",
          "DESCRIPTION": "Verwenden Sie das Portal als Headless-CMS mit Drittanbieter-Front-End-Frameworks mithilfe unserer APIs."
        }
      }
    },
    "LOADING": "Laden...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} Aufruf | {count} Aufrufe",
          "DROPDOWN_MENU": {
            "PUBLISH": "Veröffentlichen",
            "DRAFT": "Draft",
            "ARCHIVE": "Archivieren",
            "DELETE": "Löschen"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Veröffentlicht",
            "ARCHIVED": "Archiviert"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Nicht kategorisiert"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Alle Artikel",
          "MINE": "Meine",
          "DRAFT": "Draft",
          "PUBLISHED": "Veröffentlicht",
          "ARCHIVED": "Archiviert"
        },
        "CATEGORY": {
          "ALL": "Alle Kategorien"
        },
        "LOCALE": {
          "ALL": "Alle Sprachen"
        },
        "NEW_ARTICLE": "Neuer Artikel"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Artikel schreiben",
          "SUBTITLE": "Schreiben Sie einen ausführlichen Artikel – legen wir los!",
          "BUTTON_LABEL": "Neuer Artikel"
        },
        "MINE": {
          "TITLE": "Sie haben hier noch keine Artikel geschrieben",
          "SUBTITLE": "Alle von Ihnen verfassten Artikel werden hier für den schnellen Zugriff angezeigt."
        },
        "DRAFT": {
          "TITLE": "Es gibt keine Draft-Artikel",
          "SUBTITLE": "Draft-Artikel werden hier angezeigt"
        },
        "PUBLISHED": {
          "TITLE": "Es gibt keine veröffentlichten Artikel",
          "SUBTITLE": "Veröffentlichte Artikel werden hier angezeigt"
        },
        "ARCHIVED": {
          "TITLE": "Es gibt keine archivierten Artikel",
          "SUBTITLE": "Archivierte Artikel werden im Portal nicht angezeigt. Sie können damit veraltete oder überholte Seiten kennzeichnen."
        },
        "CATEGORY": {
          "TITLE": "Es gibt keine Artikel in dieser Kategorie",
          "SUBTITLE": "Artikel in dieser Kategorie werden hier angezeigt"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Neue Kategorie",
        "EDIT_CATEGORY": "Kategorie bearbeiten",
        "CATEGORIES_COUNT": "{n} Kategorie | {n} Kategorien",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategorien ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} Artikel) | {categoryName} ({categoryCount} Artikel)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Keine Kategorien gefunden",
        "SUBTITLE": "Kategorien werden hier angezeigt. Sie können eine Kategorie hinzufügen, indem Sie auf die Schaltfläche „Neue Kategorie“ klicken."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} Artikel | {count} Artikel",
        "EXPAND": "Unterkategorien anzeigen",
        "COLLAPSE": "Unterkategorien ausblenden",
        "MENU": {
          "NEW_ARTICLE": "Neuer Artikel",
          "ADD_SUBCATEGORY": "Unterkategorie hinzufügen",
          "EDIT": "Bearbeiten",
          "DELETE": "Löschen"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorie erfolgreich erstellt",
            "ERROR_MESSAGE": "Kategorie kann nicht erstellt werden"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorie erfolgreich aktualisiert",
            "ERROR_MESSAGE": "Kategorie kann nicht aktualisiert werden"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorie erfolgreich gelöscht",
            "ERROR_MESSAGE": "Kategorie kann nicht gelöscht werden"
          },
          "CONFIRM": {
            "TITLE": "Kategorie löschen",
            "DESCRIPTION": "Möchten Sie diese Kategorie wirklich löschen? Ihre Artikel werden unkategorisiert.",
            "DESCRIPTION_WITH_CHILDREN": "Möchten Sie diese Kategorie wirklich löschen? Ihre Artikel werden unkategorisiert und ihre {count} Unterkategorie wird auf die oberste Ebene verschoben. | Möchten Sie diese Kategorie wirklich löschen? Ihre Artikel werden unkategorisiert und ihre {count} Unterkategorien werden auf die oberste Ebene verschoben.",
            "CONFIRM": "Löschen"
          }
        },
        "HEADER": {
          "CREATE": "Kategorie erstellen",
          "EDIT": "Kategorie bearbeiten",
          "DESCRIPTION": "Durch das Bearbeiten einer Kategorie wird die Kategorie im öffentlich zugänglichen Portal aktualisiert.",
          "PORTAL": "Portal",
          "LOCALE": "Sprache"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Name",
            "PLACEHOLDER": "Kategoriename",
            "ERROR": "Name wird benötigt"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Kategorie-Slug für URLs",
            "ERROR": "Slug ist erforderlich",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Beschreibung",
            "PLACEHOLDER": "Geben Sie eine kurze Beschreibung der Kategorie ein.",
            "ERROR": "Beschreibung wird benötigt"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Übergeordnete Kategorie",
            "PLACEHOLDER": "Übergeordnete Kategorie auswählen",
            "NONE": "Keine (oberste Ebene)"
          }
        },
        "BUTTONS": {
          "CREATE": "Erstellen",
          "EDIT": "Aktualisieren",
          "CANCEL": "Stornieren"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Keine Sprachen verfügbar | {n} Sprache | {n} Sprachen",
      "NEW_LOCALE_BUTTON_TEXT": "Neue Sprache",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} Artikel | {count} Artikel",
        "CATEGORIES_COUNT": "{count} Kategorie | {count} Kategorien",
        "DEFAULT": "Standard",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Als Standard festlegen",
          "DELETE": "Löschen"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Neues Gebietsschema hinzufügen",
        "DESCRIPTION": "Wählen Sie die Sprache aus, in der dieser Artikel verfasst wird. Diese wird zu Ihrer Übersetzungsliste hinzugefügt, Sie können später weitere hinzufügen.",
        "COMBOBOX": {
          "PLACEHOLDER": "Sprache auswählen..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Sprache erfolgreich hinzugefügt",
          "ERROR_MESSAGE": "Sprache kann nicht hinzugefügt werden. Versuchen Sie es nochmal."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Speichern...",
          "SAVED": "Gespeichert"
        },
        "PREVIEW": "Vorschau",
        "PUBLISH": "Veröffentlichen",
        "DRAFT": "Draft",
        "ARCHIVE": "Archivieren",
        "BACK_TO_ARTICLES": "Zurück zu den Artikeln"
      },
      "DRAFT": {
        "PENDING_LABEL": "Unveröffentlichte Änderungen",
        "PROMOTE": "Änderungen veröffentlichen",
        "DISCARD": "Änderungen verwerfen",
        "PROMOTE_SUCCESS": "Draft-Änderungen im veröffentlichten Artikel übernommen",
        "PROMOTE_ERROR": "Die Draft-Änderungen konnten nicht veröffentlicht werden",
        "DISCARD_SUCCESS": "Draft-Änderungen verworfen",
        "DISCARD_ERROR": "Die Draft-Änderungen konnten nicht verworfen werden"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Versionsverlauf",
        "TITLE": "Versionsverlauf",
        "BACK": "Zurück zum Artikel",
        "LOADING": "Versionen werden geladen...",
        "EMPTY": "Noch keine Versionen. Änderungen an diesem Artikel werden hier angezeigt.",
        "EMPTY_CONTENT": "Diese Version hat keinen Inhalt.",
        "CURRENT_BADGE": "Aktuell",
        "RESTORED_BADGE": "Wiederhergestellt",
        "AUTOMATED_USER": "Automatische Aktualisierung",
        "RESTORE": "Diese Version wiederherstellen",
        "RESTORE_DIALOG": {
          "TITLE": "Diese Version wiederherstellen?",
          "DESCRIPTION": "Der Artikel wird auf den Wortlaut dieser Version zurückgesetzt. Es geht nichts verloren — der aktuelle Text bleibt im Verlauf erhalten, und ein veröffentlichter Artikel zeigt weiterhin die aktive Version, bis Sie die Änderung veröffentlichen.",
          "CONFIRM": "Wiederherstellen"
        },
        "RESTORE_SUCCESS": "Version wiederhergestellt",
        "RESTORE_ERROR": "Diese Version konnte nicht wiederhergestellt werden",
        "FETCH_ERROR": "Der Versionsverlauf konnte nicht geladen werden"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Weitere Eigenschaften",
        "TRANSLATE": "Übersetzen",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Nicht kategorisiert",
        "EDITOR_PLACEHOLDER": "Schreiben Sie etwas...",
        "HTML_EMBED": {
          "TITLE": "Benutzerdefiniertes HTML einfügen",
          "DESCRIPTION": "Fügen Sie reines HTML wie ein iframe, einen Embed oder ein Widget-Snippet ein. Es wird im veröffentlichten Artikel unverändert dargestellt.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Einfügen"
        },
        "PRIMARY_CATEGORY": "Primärkategorie"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Artikeleigenschaften",
        "SLUG": "Slug",
        "EDIT_SLUG": "Slug bearbeiten",
        "META_DESCRIPTION": "Meta-Beschreibung",
        "META_DESCRIPTION_PLACEHOLDER": "Meta-Beschreibung hinzufügen",
        "META_TITLE": "Meta-Titel",
        "META_TITLE_PLACEHOLDER": "Meta-Titel hinzufügen",
        "META_TAGS": "Meta-Tags",
        "META_TAGS_PLACEHOLDER": "Meta-Tags hinzufügen",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Sprachvarianten",
        "LANGUAGE_MUTATIONS_EMPTY": "Noch keine verknüpften Artikel",
        "ADD_MUTATION": "Hinzufügen",
        "REMOVE_MUTATION": "Entfernen"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Sprachvarianten verknüpfen",
        "SEARCH_PLACEHOLDER": "Artikel nach Titel suchen",
        "EMPTY": "Keine passenden Artikel",
        "CANCEL": "Abbrechen",
        "ADD_SELECTED": "Auswahl hinzufügen",
        "SUCCESS": "Varianten aktualisiert",
        "ERROR": "Fehler beim Aktualisieren der Varianten"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Artikel übersetzen",
        "DESCRIPTION": "Wählen Sie die Sprachen aus, in die Sie diesen Artikel übersetzen möchten. Sprachen, die bereits übersetzt wurden, werden zur Überprüfung erneut als Draft übersetzt.",
        "EMPTY": "Keine weiteren Sprachen verfügbar",
        "CONNECTED_BADGE": "Übersetzt",
        "CANCEL": "Abbrechen",
        "TRANSLATE": "Übersetzen",
        "SUCCESS": "Die Übersetzung beginnt in Kürze. Die übersetzten Artikel werden bald als Sprachvarianten angezeigt.",
        "ERROR": "Übersetzung konnte nicht gestartet werden"
      },
      "SLUG_DIALOG": {
        "TITLE": "Artikel-URL bearbeiten",
        "DESCRIPTION": "Ändern Sie den beschreibenden Teil des Slugs dieses Artikels. Alte Links funktionieren weiterhin — sie leiten automatisch hierher weiter.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "Das numerische Präfix ist eine dauerhafte Kennung und kann nicht geändert werden.",
        "PREVIEW": "Artikel-URL",
        "CANCEL": "Abbrechen",
        "SAVE": "Speichern",
        "SUCCESS": "Artikel-URL aktualisiert",
        "ERROR": "Artikel-URL konnte nicht aktualisiert werden"
      },
      "API": {
        "ERROR": "Fehler beim Speichern des Artikels"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Neues Portal",
      "PORTALS": "Portale",
      "CREATE_PORTAL": "Mehrere Portale erstellen und verwalten",
      "ARTICLES": "Artikel",
      "DOMAIN": "Domain",
      "PORTAL_NAME": "Portalname"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Neues Portal erstellen",
      "DESCRIPTION": "Geben Sie Ihrem Portal einen Namen und erstellen Sie einen benutzerfreundlichen URL-Slug. Sie können beides später in den Einstellungen ändern.",
      "CONFIRM_BUTTON_LABEL": "Erstellen",
      "NAME": {
        "LABEL": "Name",
        "PLACEHOLDER": "Benutzerhandbuch",
        "MESSAGE": "Wählen Sie einen Namen für Ihr Portal.",
        "ERROR": "Name wird benötigt"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug ist erforderlich",
        "FORMAT_ERROR": "Verwenden Sie nur Buchstaben, Ziffern und Bindestriche, zum Beispiel: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Bild konnte nicht hochgeladen werden! Versuchen Sie es erneut",
          "IMAGE_UPLOAD_SUCCESS": "Bild erfolgreich hinzugefügt. Bitte klicken Sie auf „Änderungen speichern“, um das Logo zu speichern",
          "IMAGE_DELETE_SUCCESS": "Logo erfolgreich gelöscht",
          "IMAGE_DELETE_ERROR": "Logo kann nicht gelöscht werden",
          "IMAGE_UPLOAD_SIZE_ERROR": "Bildgröße sollte kleiner als {size}MB sein"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Name",
          "PLACEHOLDER": "Portalname",
          "ERROR": "Name wird benötigt"
        },
        "HEADER_TEXT": {
          "LABEL": "Kopfzeilentext",
          "PLACEHOLDER": "Portal-Header-Text"
        },
        "PAGE_TITLE": {
          "LABEL": "Seitentitel",
          "PLACEHOLDER": "Titel der Portalseite"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Startseiten-Link",
          "PLACEHOLDER": "Link zur Startseite des Portals",
          "ERROR": "Ungültige URL. Der Startseiten-Link muss mit 'http://' oder 'https://' beginnen."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal-Slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Live-Chat-Widget",
          "PLACEHOLDER": "Live-Chat-Widget auswählen",
          "HELP_TEXT": "Wählen Sie ein Live-Chat-Widget aus, das in Ihrem Hilfezentrum angezeigt wird"
        },
        "LINK_TARGET": {
          "LABEL": "Linkziel",
          "HELP_TEXT": "Wählen Sie, ob Links in Artikeln im aktuellen Fenster oder in einem neuen geöffnet werden.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Aktuelles Fenster",
            "NEW_WINDOW": "Neues Fenster"
          }
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Öffentlich zugänglich",
          "HELP_TEXT": "Portal für alle mit Link zugänglich machen.",
          "OPTIONS": {
            "PUBLIC": "Ja",
            "PRIVATE": "Nein"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Standardbildgröße",
          "HELP_TEXT": "Größe, die auf jedes Bild angewendet wird, das Sie in einen Artikel einfügen. Wählen Sie Original, um Bilder in ihrer eigenen Größe einzufügen und stattdessen für jedes Bild eine Größe auszuwählen."
        },
        "BRAND_COLOR": {
          "LABEL": "Markenfarbe"
        },
        "CUSTOM_HTML": {
          "LABEL": "Benutzerdefiniertes HTML",
          "PLACEHOLDER": "<!-- Fügen Sie hier Ihren Analyse- oder Tracking-Code ein -->",
          "HELP_TEXT": "Wird am Anfang des <body>-Tags auf jeder Seite des Hilfezentrums eingefügt. Verwenden Sie es für Google Analytics, Google Tag Manager oder einen anderen Tracking-Code. Der Code wird genau so gerendert, wie er eingegeben wurde, und wird nicht validiert."
        },
        "SAVE_CHANGES": "Änderungen speichern"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Benutzerdefinierte Domain",
          "LABEL": "Benutzerdefinierte Domain:",
          "DESCRIPTION": "Sie können Ihr Portal auf einer benutzerdefinierten Domain hosten. Wenn Ihre Website beispielsweise yourdomain.com ist und Sie Ihr Portal unter docs.yourdomain.com verfügbar machen möchten, geben Sie dies einfach in dieses Feld ein.",
          "PLACEHOLDER": "Benutzerdefinierte Domain des Portals",
          "EDIT_BUTTON": "Benutzerdefinierte Domain bearbeiten",
          "ADD_BUTTON": "Benutzerdefinierte Domain hinzufügen",
          "DIALOG": {
            "ADD_HEADER": "Benutzerdefinierte Domain hinzufügen",
            "EDIT_HEADER": "Benutzerdefinierte Domain bearbeiten",
            "ADD_CONFIRM_BUTTON_LABEL": "Domain hinzufügen",
            "EDIT_CONFIRM_BUTTON_LABEL": "Domain aktualisieren",
            "LABEL": "Benutzerdefinierte Domain",
            "PLACEHOLDER": "Benutzerdefinierte Domain des Portals",
            "ERROR": "Benutzerdefinierte Domain ist erforderlich"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS-Konfiguration",
            "DESCRIPTION": "Melden Sie sich bei Ihrem DNS-Anbieter an und fügen Sie den folgenden CNAME-Eintrag für Ihre Subdomain hinzu.",
            "HELP_TEXT": "Sobald dies erledigt ist, können Sie sich an unseren Support wenden, um das automatisch generierte SSL-Zertifikat anzufordern.",
            "CONFIRM_BUTTON_LABEL": "Verstanden!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "{portalName} löschen",
          "HEADER": "Portal löschen",
          "DESCRIPTION": "Dieses Portal dauerhaft löschen. Diese Aktion kann nicht rückgängig gemacht werden",
          "DIALOG": {
            "HEADER": "Möchten Sie {portalName} wirklich löschen?",
            "DESCRIPTION": "Dies ist eine dauerhafte Aktion, die nicht rückgängig gemacht werden kann.",
            "CONFIRM_BUTTON_LABEL": "Löschen"
          }
        },
        "EDIT_CONFIGURATION": "Konfiguration bearbeiten"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal erfolgreich erstellt",
          "ERROR_MESSAGE": "Portal kann nicht erstellt werden"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal erfolgreich aktualisiert",
          "ERROR_MESSAGE": "Portal kann nicht aktualisiert werden"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Anhänge",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Datei hinzufügen",
      "DROP_HERE": "Dateien hierher ziehen",
      "COPY_LINK": "Link kopieren",
      "LINK_COPIED": "Link in die Zwischenablage kopiert",
      "COPY_FAILED": "Link konnte nicht kopiert werden",
      "DELETE": "Löschen",
      "CANCEL": "Abbrechen",
      "QUEUED": "In Warteschlange",
      "UPLOADING": "Wird hochgeladen",
      "UPLOAD_FAILED": "Datei konnte nicht hochgeladen werden",
      "FILE_TOO_LARGE": "Datei überschreitet die Größenbeschränkung von 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Übersetzungswörterbuch",
        "DESCRIPTION": "Hier festgelegte Begriffe werden dem KI-Übersetzungs-Prompt hinzugefügt, damit sie immer gleich übersetzt werden. Der Hauptbegriff ist in {locale} verfasst."
      },
      "NEW_TERM": "Neuer Begriff",
      "EMPTY_STATE": {
        "TITLE": "Noch keine Wörterbuchbegriffe",
        "SUBTITLE": "Fügen Sie für jede Sprache einen Begriff und dessen Übersetzung hinzu. Beim Übersetzen eines Artikels werden diese Begriffe berücksichtigt, damit Ihre Produktbezeichnungen konsistent bleiben."
      },
      "LIST": {
        "TERM": "Begriff",
        "TRANSLATIONS": "Übersetzungen",
        "ACTIONS": "Aktionen"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Begriff hinzufügen",
          "EDIT": "Begriff bearbeiten",
          "DESCRIPTION": "Der unten stehende Begriff wird bei der KI-Übersetzung Ihrer Hilfezentrum-Artikel durchgesetzt.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Hauptsprache"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Begriff ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Begriff ist erforderlich"
          },
          "DESCRIPTION": {
            "LABEL": "Kontext / Anmerkungen (optional)",
            "PLACEHOLDER": "Wann und wie dieser Begriff verwendet wird, um dem Übersetzer die Unterscheidung zu erleichtern."
          },
          "TRANSLATIONS": "Übersetzungen",
          "TRANSLATION_PLACEHOLDER": "Leer lassen, damit die KI frei übersetzen kann",
          "AUTO_TRANSLATE": {
            "BUTTON": "Alle automatisch übersetzen",
            "CONFIRM": "Mit KI in {count} Sprachen übersetzen?",
            "CONFIRM_BUTTON": "Übersetzen",
            "CANCEL": "Abbrechen",
            "SUCCESS": "Übersetzungen erstellt — bitte überprüfen und speichern",
            "ERROR": "Automatische Übersetzung fehlgeschlagen, bitte versuchen Sie es erneut"
          }
        },
        "BUTTONS": {
          "CREATE": "Begriff hinzufügen",
          "EDIT": "Speichern",
          "CANCEL": "Abbrechen"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Begriff erfolgreich hinzugefügt",
            "ERROR_MESSAGE": "Der Begriff konnte nicht hinzugefügt werden, bitte versuchen Sie es erneut"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Begriff erfolgreich aktualisiert",
            "ERROR_MESSAGE": "Der Begriff konnte nicht aktualisiert werden, bitte versuchen Sie es erneut"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Begriff löschen",
          "DESCRIPTION": "Möchten Sie diesen Begriff wirklich löschen? Er wird bei der Übersetzung nicht mehr berücksichtigt.",
          "CONFIRM": "Löschen"
        },
        "API": {
          "SUCCESS_MESSAGE": "Begriff erfolgreich gelöscht",
          "ERROR_MESSAGE": "Der Begriff konnte nicht gelöscht werden, bitte versuchen Sie es erneut"
        }
      }
    }
  }
}
